import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { getToken } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import { gemsRouterContract, reserveWETHForFirstBuying, tokenReservesForFirstBuying } from "../../utils/Enviroment";

const AmountOut = () => {
    const { account } = useWeb3React();
    const web3 = useWeb3();
    const contract = getToken(gemsRouterContract, web3);

    const AmountOutHook = useCallback(
        async (amount) => {
            if (!amount) return "0";
            const feeAmountInWei = web3.utils.toBN(web3.utils.toWei(String(amount), "ether"));
            const rockReservesInWei = web3.utils.toBN(web3.utils.toWei(tokenReservesForFirstBuying, "ether"));

            const amountOut = await contract?.methods
                ?.getAmountOutWithFee(feeAmountInWei, reserveWETHForFirstBuying, rockReservesInWei)
                .call();
            const formattedAmount = web3.utils.fromWei(amountOut.toString(), "ether");
            return formattedAmount;
        },
        [web3, account]
    );

    return { AmountOutHook };
};

export default AmountOut;
